<template>
  <form @submit.prevent="fnLogin()">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-12">
        <div class="form-group mb-4">
          <input
            class="form-control"
            type="text"
            id="email"
            autocomplete="off_email"
            placeholder=" "
            v-model="user.email"
          />
          <label class="floatingLabel text-secondary" for="email"
            >Enter email</label
          >
          <div class="invalid-feedback" v-if="errors.email">
            {{ errors.email[0] }}
          </div>
        </div>
        <div class="form-group mb-4">
          <input
            class="form-control"
            type="password"
            id="password"
            autocomplete="off_password"
            placeholder=" "
            v-model="user.password"
          />
          <label class="floatingLabel text-secondary" for="password"
            >Password</label
          >
          <div class="invalid-feedback" v-if="errors.password">
            {{ errors.password[0] }}
          </div>
        </div>

        <div class="d-flex justify-content-between">
          <div class="align-self-center">
            <router-link to="/recover-password">Forgot password?</router-link>
          </div>

          <div class="align-self-center">
            <button type="submit" class="btn btn-primary float-right">
              Sign in
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as authService from '../../../../services/auth.service'
import * as messageService from '../../../../services/message.service'

export default {
  name: 'SignIn2Form',
  props: ['formType', 'email', 'password'],
  data: () => ({
    user: {
      email: '',
      password: '',
      remember_me: false
    },
    errors: {}
  }),
  computed: {
    ...mapGetters(['getIsUserSettingUpdate'])
  },
  methods: {
    ...mapActions(['fetchIsUserSettingUpdate']),
    fnLogin: async function () {
      try {
        const response = await authService.login(this.user)
        this.errors = {}
        this.fetchIsUserSettingUpdate(true)

        if (
          response.token_scope == 'admin' ||
          response.token_scope == 'staff'
        ) {
          this.$router.push({ name: 'admin.dashboard' })
        } else if (response.token_scope == 'bdm') {
          this.$router.push({ name: 'bdm.dashboard' })
        } else if (response.token_scope == 'dealer') {
          this.$router.push({ name: 'dealer.dashboard' })
        } else if (response.token_scope == 'referral-partner') {
          this.$router.push({ name: 'referralPartner.dashboard' })
        }

        this.fetchIsUserSettingUpdate(false)
      } catch (error) {
        switch (error.response.status) {
          case 401:
            this.errors = error.response.data.errors
            messageService.fnSweetAlertErrorToast(
              'Login',
              error.response.data.message
            )
            break
          case 403:
            this.errors = error.response.data.errors
            messageService.fnSweetAlertErrorToast(
              'Login',
              error.response.data.message
            )
            break
          case 422:
            this.errors = error.response.data.errors
            messageService.fnSweetAlertErrorToast(
              'Login',
              error.response.data.message
            )
            break
          case 500:
            messageService.fnSweetAlertErrorToast(
              'Login',
              error.response.data.message
            )
            break
          default:
            messageService.fnSweetAlertErrorToast(
              'Login',
              'Something wrong, please try again!'
            )
            break
        }
        this.fetchIsUserSettingUpdate(false)
      }
    }
  }
}
</script>
